import floorDecimals from "./floorDecimals";
import sanitizeMinMaxFractionDigits from "./sanitizeMinMaxFractionDigits";

const formatFloat = (
  value: number,
  locale: string,
  maximumFractionDigits?: number,
) => {
  const sanitizedMinMax = sanitizeMinMaxFractionDigits(maximumFractionDigits);
  // Floor to the same default the formatter uses: a currency config without
  // maximumFractionDigits would otherwise floor with `e${undefined}` (NaN).
  const result = floorDecimals(
    value,
    maximumFractionDigits ?? sanitizedMinMax.maximumFractionDigits,
  );
  return new Intl.NumberFormat(locale, sanitizedMinMax).format(result);
};

export default formatFloat;
